import { HalfContainer } from "common/common.styled";
import Button from "components/Button";
import { Grid } from "components/Grid/Grid";
import TabSelection from "components/TabSelection";
import Text from "components/Text";

import { Country, State } from "country-state-city";
import { FC } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import theme from "theme";
import SuggestiveTextInput from "../JobDetails/SuggestiveTextInput";
import { JobPurposeWrapper } from "../JobPurpose/JobPurpose.styled";
import { LocationContentWrapper } from "./JobLocation.styled";
import { useJobLocation } from "./useJobLocation";
export const JobLocation: FC = () => {
    const {
        applicationsFrom,
        handleChangeAppFrom,
        purposeName,
        agencyName,
        applicationCountryError,
        projectLocation,
        projectLocationErrors,
        applicationCountry,
        handleProjectLocationChange,
        handleApplicationCountryChange,
        handleBack,
        handleNext,
        countryCode,
        setCountryCode,
    } = useJobLocation();

    return (
        <JobPurposeWrapper>
            <HalfContainer>
                <Text variant="body3" color={theme.colors.grey.primary}>
                    I am posting a job on behalf of{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {agencyName}
                    </Text>{" "}
                    for a{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {purposeName}
                    </Text>
                    .
                </Text>
                <LocationContentWrapper>
                    <Text variant="button1">
                        What is the project's location?
                    </Text>
                    <Grid row={true} columnGap={2} marginBottom={1}>
                        <SuggestiveTextInput
                            options={Country.getAllCountries().map((val) => {
                                return {
                                    label: val.name,
                                    value: val.name,
                                    code: val.isoCode,
                                };
                            })}
                            label="Country"
                            placeholder="Eg. UAE"
                            name="country"
                            disabled
                            value={projectLocation.country}
                            errorText={projectLocationErrors.country}
                            onChange={(value) => {
                                handleProjectLocationChange("country", value);
                                setCountryCode(
                                    Country.getAllCountries().filter(
                                        (val) => val.name === value
                                    )[0]?.isoCode
                                );
                            }}
                        />
                        <SuggestiveTextInput
                            options={State.getStatesOfCountry(countryCode).map(
                                (val) => {
                                    return {
                                        label: val.name,
                                        value: val.name,
                                    };
                                }
                            )}
                            label="City"
                            placeholder="Select City"
                            name="city"
                            value={projectLocation.city}
                            errorText={projectLocationErrors.city}
                            onChange={(value) => {
                                handleProjectLocationChange("city", value);
                            }}
                        />
                    </Grid>
                    <Text variant="button1">
                        I want applications only from?
                    </Text>
                    <TabSelection
                        onChange={handleChangeAppFrom}
                        defaultActive={applicationsFrom}
                        options={[
                            {
                                label: "Worldwide",
                                value: "worldwide",
                            },
                            {
                                label: "Select Country",
                                value: "selectCountry",
                            },
                        ]}
                    />

                    {(applicationsFrom === "selectCountry" ||
                        applicationsFrom === null) && (
                        <SuggestiveTextInput
                            options={Country.getAllCountries().map((val) => {
                                return {
                                    label: val.name,
                                    value: val.name,
                                    code: val.isoCode,
                                };
                            })}
                            label="Country"
                            placeholder="Select Country"
                            value={`${applicationCountry[0]}`}
                            errorText={applicationCountryError}
                            onChange={(value) =>
                                handleApplicationCountryChange(value)
                            }
                        />
                    )}
                    <Grid marginTop={3} columnGap={1}>
                        <Button
                            type="button"
                            variant="outlined"
                            icon={<BsArrowLeft />}
                            iconPosition="prefix"
                            onClick={handleBack}
                        >
                            Back
                        </Button>
                        <Button
                            type="button"
                            variant="filled"
                            icon={<BsArrowRight />}
                            iconPosition="suffix"
                            onClick={handleNext}
                        >
                            Next
                        </Button>
                    </Grid>
                </LocationContentWrapper>
            </HalfContainer>
        </JobPurposeWrapper>
    );
};
